/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface FormsSetupFormsJotformArgs {
  source: string;
  onClick: () => void;
}

export default class FormsSetupFormsJotform extends Component<FormsSetupFormsJotformArgs> {
  jotformImage = new URL('cio/assets/images/integrations/jotform.svg', import.meta.url).toString();
}
